<style scoped>
  .bg-n-r {
    background: #fff;
    padding: 10px 20px;
  }
</style>
<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :close-on-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="display"
        :label="label"
        :placeholder="placeholder"

        clearable
        readonly
      
        v-bind="$attrs"
        @click:clear="clear"
        v-on="on"
      />
    </template>
    <div class="bg-n-r">
      <div style="display: flex;align-items: center;">
        <v-text-field 
          v-model="my_value[keys[0]]"
          style="width:100px"
          placeholder="最小值" 
          small
          type="number"
        />
        <div>-</div>
        <v-text-field 
          v-model="my_value[keys[1]]"
          placeholder="最大值" 
          type="number"
          small
          style="width:100px"
        />
      </div>
      <v-spacer />
      <div style="text-align: right">
        <v-btn
          text
          @click="close"
        >
          关闭
        </v-btn>
        <!-- <v-btn
          text
          color="warning"
          @click="clear"
        >
          清除
        </v-btn> -->
        <v-btn
          text
          color="primary"
          :disabled="dataLen!==2"
          @click="submit"
        >
          确定
        </v-btn>
      </div>
    </div>
  </v-menu>
</template>
<script>
 
  export default {
    props: {
      value: {
        type: Object
      },
      label: {
        type: String,
        default: '选择日期'
      },
      keys: {
        type: Array,
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
    },
    data() {
      return {
        menu: false,
        date: [],
        my_value: {}
      }
    },
    computed: {
      dataLen() {
        return Object.values(this.my_value).filter(i => !!i).length
      },
      display() {
        const start_key = this.keys[0]
        const end_key = this.keys[1]
        const start = this.value[start_key]
        const end = this.value[end_key]
        const arr = [start, end].filter(item => !!item)
        return arr.length ? arr.join('-') : ''
      }
    },
 
    methods: {
      submit() {
        const start_key = this.keys[0]
        const end_key = this.keys[1]
        this.value[start_key] = this.my_value[start_key]
        this.value[end_key] = this.my_value[end_key]
        this.menu = false
        this.$nextTick(() => this.$emit('submit'))
      },
      clear() {
        const start_key = this.keys[0]
        const end_key = this.keys[1]
        this.value[start_key] = this.my_value[start_key] = null
        this.value[end_key] = this.my_value[end_key] = null
        this.menu = false
        this.$nextTick(() => this.$emit('submit'))
      },
  
      close() {
        this.menu = false
      },
  
    }
  }
</script>
